import { useState } from 'react';

import { NoDataDisplay, Tab } from '@pukka/ui-components';

import { DetailedOutlet } from '../comparison.state';

import ColumnChart from './ColumnChart';
import { COMPARISON_TAB_DATA, ComparisonVariableNames } from './constants';

const DUMMY_DATA = [
  {
    id: 1,
    name: '',
    grossSales: 666000,
  },
  {
    id: 2,
    name: '',
    grossSales: 1333500,
  },
];

interface GraphComparisonProps {
  readonly data: DetailedOutlet[];
  readonly isFeatureAvailable: boolean;
}

interface GraphComparisonContentProps extends GraphComparisonProps {
  readonly display: ComparisonVariableNames;
}

function GraphComparisonContent({ isFeatureAvailable, data, display }: GraphComparisonContentProps) {
  if (!isFeatureAvailable) {
    return <ColumnChart dataDisplay={display} data={DUMMY_DATA} className="h-72" />;
  }

  if (data.length >= 2) {
    return <ColumnChart dataDisplay={display} data={data} className="h-72" />;
  }

  return <NoDataDisplay isLoading={false} imageSize={100} placeholder="Pick outlets to show data" className="h-72" />;
}

function GraphComparison({ data, isFeatureAvailable }: GraphComparisonProps) {
  const [dataDisplay, setDataDisplay] = useState<ComparisonVariableNames>('grossSales');

  return (
    <div>
      <div className="mb-5 border-b border-neutral-300 pb-1">
        <h2 className="text-lg text-neutral-700">GRAPH COMPARISON</h2>
      </div>

      <Tab
        variant="capsule"
        data={COMPARISON_TAB_DATA}
        value={dataDisplay}
        disabled={data.length < 2}
        onChange={setDataDisplay as (value: string) => void}
        content={<GraphComparisonContent data={data} isFeatureAvailable={isFeatureAvailable} display={dataDisplay} />}
      />
    </div>
  );
}

export { GraphComparison };
